<template>
  <div class="cotton-right-button-wrap">
    <template v-for="btn in btns">
      <div
        v-if="btn.show()"
        class="cotton-right-button_item"
        :class="{ 'is-active': isActive(btn.key) }"
        :key="btn.text"
        @click="open(btn.key)"
        @mouseover="handleMouseover(btn.key, $event)"
        @mouseleave="hidePopover"
      >
        <img :src="btn.icon" :alt="btn.text" />
        <span>{{ btn.text }}</span>
      </div>
    </template>

    <MPopover
      :visible="visible"
      :position="popopPosition"
      @mouseover.native="showPopover"
      @mouseleave.native="hidePopover"
    >
      <div class="company-list">
        <div class="company-list_title">切换公司</div>
        <ul>
          <li
            v-for="office in offices"
            :class="{
              active: model.officeId === office.id,
              'is-alarm': deptStateMap[office.id].isAlarm
            }"
            :key="office.id"
            @click="handleSwitchCompany(office)"
          >
            {{ office.name }}
          </li>
        </ul>
      </div>
    </MPopover>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import MPopover from '@/components/mPopover/index.vue';

import { getStateHighLevelOptionBy } from '@/utils/deviceUtils/state';
import { officeTypeDict } from '@/utils/const/office';
import { isEmpty } from '@/utils/is';

const prefix = '/static/image/cotton/';

export default {
  components: { MPopover },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      offices: [],
      visible: false,
      popopPosition: {},
      btns: [
        {
          text: '实时监测',
          key: 'cottonSmolderingMonitor',
          icon: `${prefix}realtime-monitoring.png`,
          show: () => true
        },
        {
          text: '检测记录',
          key: 'cottonBaleDetectionRecord',
          show: () => +this.model.officeType === officeTypeDict.getKeyByText('堆场'),
          icon: `${prefix}detection-record.png`
        },
        {
          text: '报警记录',
          key: 'cottonBaleAlarmRecord',
          icon: `${prefix}alarm-record.png`,
          show: () => true
        },
        // {
        //   text: '巡检记录',
        //   key: 'cottonBaleInspectionRecord',
        //   icon: `${prefix}inspection-record.png`,
        //   show: () => +this.model.officeType === officeTypeDict.getKeyByText('堆场')
        // },
        {
          text: '检测统计',
          key: 'cottonDetectionStat',
          icon: `${prefix}detection-stat.png`,
          show: () => +this.model.officeType === officeTypeDict.getKeyByText('堆场')
        },
        {
          text: '报警统计',
          key: 'cottonAlarmStat',
          icon: `${prefix}alarm-stat.png`,
          show: () => true
        }
      ]
    };
  },
  computed: {
    activeMenu() {
      return this.$route.name;
    },
    ...mapState('socket', ['deviceTree', 'deviceIdMap']),
    cottonDeptList() {
      if (isEmpty(this.deviceTree)) return [];

      return this.deviceTree.filter(e => {
        return [4, 3].includes(+e.type);
      });
    },
    deptStateMap() {
      const map = {};

      this.cottonDeptList.forEach(e => {
        map[e.id] = { ...getStateHighLevelOptionBy(e.children, { useLevel2: true }) };
      });

      return map;
    }
  },
  methods: {
    handleSwitchCompany(office) {
      const name = officeTypeDict.getOptionByKey(office.type).routeName;

      this.$router.push({
        name,
        params: {
          id: office.id
        }
      });
    },
    showPopover() {
      if (this.timer) clearTimeout(this.timer);

      this.visible = true;
    },
    hidePopover() {
      if (this.timer) clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.visible = false;
      }, 300);
    },
    handleMouseover(key) {
      if (key !== 'cottonSmolderingMonitor') return;

      this.showPopover();

      this.popopPosition = {
        left: 0,
        top: '20px',
        transform: 'translateX(-100%)'
      };
    },
    isActive(key) {
      return this.activeMenu.indexOf(key) !== -1;
    },
    open(key) {
      if (this.activeMenu === key) return;

      const isMonitor = key === 'cottonSmolderingMonitor';

      if (isMonitor) {
        let params = this.model.officeId ? { id: this.model.officeId } : undefined;

        const name = officeTypeDict.getOptionByKey(this.model.officeType)?.routeName;

        if (isEmpty(name)) return;

        this.$router.push({
          name,
          params
        });
      } else {
        this.$router.push({
          name: key
        });
      }
    }
  },
  watch: {
    deviceTree: {
      handler(n) {
        const list = [officeTypeDict.getKeyByText('堆场'), officeTypeDict.getKeyByText('轧花厂')];

        this.offices.splice(0, Infinity);

        n?.forEach(e => {
          if (list.includes(+e.type)) {
            this.offices.push(e);
          }
        });
      },
      immediate: true
    },
    '$route.params': {
      handler() {
        const id = this.$route.params.id;

        if (isEmpty(id)) return;

        this.model.officeType = this.deviceIdMap[id].type;

        this.model.officeId = id;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.cotton-right-button-wrap {
  border: 2px solid var(--cotton-right-btn-border);
  border-radius: 110px;
  backdrop-filter: blur(4px);

  box-sizing: border-box;

  width: 110px;
  height: calc(100% - var(--header-height) - 15px);

  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  gap: 15px;

  padding: 55px 10px;

  position: absolute;
  right: 15px;
  bottom: 15px;
  z-index: 7;

  .cotton-right-button_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;

    cursor: pointer;

    transition: all 0.3s;

    &.is-active {
      filter: brightness(1.5);
      scale: 1.1;

      span {
        font-weight: 600;
        color: var(--cotton-right-btn-active-text);
      }
    }

    &:hover {
      filter: brightness(1.5);
    }

    img {
      width: 90%;
    }

    span {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: var(--cotton-right-btn-text);
      line-height: 23px;

      transition: all 0.3s;
    }
  }

  .company-list {
    height: 100%;

    --title-height: 38px;

    &_title {
      height: var(--title-height);
      line-height: var(--title-height);
      text-align: center;
      font-size: 16px;
    }

    ul {
      height: calc(100% - var(--title-height) - 2px);
      overflow: auto;
      @include scrollar-style-thin;

      li {
        width: 100%;
        padding-left: 10%;
        line-height: 36px;
        box-sizing: border-box;
        position: relative;

        cursor: pointer;

        &:hover,
        &.active {
          background: var(--cotton-right-btn-hover-bg);
        }

        &.is-alarm {
          background: var(--cotton-right-btn-alarm-bg);
        }

        &.active {
          &::before {
            content: '';

            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);

            width: 3px;
            height: 3px;

            background: var(--cotton-right-btn-active-dot);
            border-radius: 50%;
          }
        }
      }
    }
  }
}
</style>
